import { useState, useEffect } from "react";

/**
 * Manages sidebar open/close state with mobile awareness.
 *
 * On mobile, the sidebar always starts closed — prevents stale desktop
 * localStorage (`isMenuOpen=true`) from booting with sidebar + backdrop
 * blocking content. A useEffect auto-closes the sidebar when the viewport
 * transitions to mobile (e.g. device rotation).
 *
 * Extracted from Dashboard.js so both guards (init gate + viewport-transition
 * effect) can be tested against the real hook, not a hand-copied replica.
 */
export function useMobileSidebarState(isMobile) {
  const [openMenu, setOpenMenu] = useState(() => {
    if (isMobile) return false;
    return !!JSON.parse(localStorage.getItem("isMenuOpen"));
  });

  // Auto-close sidebar when viewport transitions to mobile
  useEffect(() => {
    if (isMobile) {
      setOpenMenu(false);
    }
  }, [isMobile]);

  return [openMenu, setOpenMenu];
}
